class Socket {
  instance = null;
  constructor(url) {
    this.instance = new WebSocket(url);
  }
  onOpen(callback) {
    this.instance.onopen = (event) => callback(event)
  }
  onMessage(callback) {
    this.instance.onmessage = (event) => callback(event)
  }
  onError(callback) {
    this.instance.onerror = (event) => {
      return callback(event)
    }
  }
  send(data) {
    return new Promise((resolve, reject) => {
      if (this.instance.readyState === WebSocket.OPEN) {
        if (typeof data === "object") {
          data = JSON.stringify(data);
        }
        this.instance.send(data);
        resolve("消息发送成功");
      } else {
        reject("WebSocket未打开，无法发送消息");
      }
    });
  }
  onClose(callback) {
    this.instance.onclose = (event) => callback(event)
  }
  disconnect() {
    this.instance.close();
    this.instance = null;
  }
}

export const socket = (url) => new Socket(url);